import React from 'react';
import { FileText, Download, ArrowRight, BookOpen } from 'lucide-react';
import '../styles/Insights.css';
import { Link } from 'react-router-dom';

const Insights = () => {
  const insights = [
    {
      type: "Downloadable PDF",
      icon: <Download className="insight-icon" />,
      title: "Board-Ready SaaS Documentation Checklist",
      description: "A comprehensive guide to creating executive documentation that demonstrates reliability, security, and governance.",
      cta: "Download PDF",
      featured: true
    },
    {
      type: "Article",
      icon: <BookOpen className="insight-icon" />,
      title: "From Demos to Trust: The Architecture Signals Execs Value",
      description: "Learn what C-level decision makers look for when evaluating SaaS platforms and how to position your architecture accordingly.",
      cta: "Read Article",
      featured: true
    },
    {
      type: "Guide",
      icon: <FileText className="insight-icon" />,
      title: "Azure Security Baseline Implementation",
      description: "Step-by-step guide to implementing Microsoft's security baseline for Azure deployments.",
      cta: "View Guide",
      featured: false
    }
  ];

  return (
    <section id="insights" className="insights-section">
      <div className="insights-container">
        <div className="section-header-center">
          <span className="section-badge">Leadership Insights</span>
          <h2 className="section-title">
            Resources for Technical Decision Makers
          </h2>
          <p className="section-description">
            Expert guidance on enterprise architecture, reliability, and strategic technology decisions.
          </p>
        </div>

        <div className="insights-grid">
          {insights.map((insight, index) => (
            <div
              key={index}
              className={`insight-card ${insight.featured ? 'insight-featured' : ''}`}
            >
              <div className="insight-type-badge">
                {insight.icon}
                <span>{insight.type}</span>
              </div>

              <h3 className="insight-title">{insight.title}</h3>
              <p className="insight-description">{insight.description}</p>

              <button className="insight-cta-button">
                {insight.cta}
                <ArrowRight className="insight-cta-icon" />
              </button>
            </div>
          ))}
        </div>

        <div className="insights-footer">
          <p className="insights-footer-text">
            Want to read more insights like these?
          </p>
          <Link to="/blog" className="insights-footer-button">
            Visit Our Blog
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Insights;